import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import "./Index.css";
import {
    getDistrictTownList,
    getZoneDistrictTotalByCity,
    initialWebWillMount,
    searchZoneListView
} from "../../../../actions/ZoneAction";
import SearchResult from "./SearchResult";
import SearchCondition from "../components/SearchCondition";
import LogoHeader from "../components/LogoHeader";
import MTabBar from '../../../../../../components/MTabBar';



class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formatMessage: this.props.intl['formatMessage'],

        }
    }

    componentWillMount() {
        const self = this;
        initialWebWillMount(this.props, (city, condition) => {
            condition.currentPage = 1;
            condition.pageSize = 20;
            condition.recommendOrderFlag = 1
            condition.zoneCity = city;
            condition.zonePointWest = undefined;
            condition.zonePointEast = undefined;//东
            condition.zonePointSouth = undefined;//南
            condition.zonePointNorth = undefined;//北
            condition.zoneDistrictList = this.props.selectedDistrictList
            self.props.dispatch(getZoneDistrictTotalByCity(city));
            self.props.dispatch(getDistrictTownList(city));
            self.props.dispatch(getDistrictTownList(city));
            self.props.dispatch(searchZoneListView(condition, [], this.props.zoneCoordinateMap, self.state.formatMessage, true));//列表
            // self.props.dispatch(searchShowZoneList(searchCondition, self.state.formatMessage));//地图
        });
    }

    _constructBMapCallback(bMap) {
        this.setState({ bMap: bMap })
    }

    render() {
        const { showMap, router } = this.props;
        return (
            <div className="zone-list-box tabbarBottom">
                <LogoHeader />
                <SearchCondition inList={true} {...this.props} />

                <SearchResult {...this.props} />

                <MTabBar router={router} index={1} />
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        searchCondition: store.WMSZoneReducer.searchCondition,
        cityName: store.WMSZoneReducer.cityName,
        zoneCoordinateMap: store.WMSZoneReducer.zoneCoordinateMap,
        currentLocation: store.WMSZoneReducer.currentLocation,
        selectedDistrictList: store.WMSZoneReducer.selectedDistrictList,
    }
}

export default connect(mapStateToProps)(injectIntl(Index));